import React, { useEffect } from 'react';

import { useWatch } from 'react-hook-form';

import { useHandleForm } from '@shared/hooks';

import { useJournalSearchQueryState } from '.';
import { IFormSchema } from '../../model/FormSchema';

export const useJournalSearchForm = () => {
    const { control, errors, handleSubmit, clearErrors, setValue } = useHandleForm<IFormSchema>({
        onSubmit: async (data) => console.log('Form data: ', data),
        defaultValues: { search: '' },
        resetEnable: false,
        mode: 'onChange',
    });

    const searchValue = useWatch<IFormSchema>({ control, name: 'search' });

    const { state, setState: setQuerySearchValue } = useJournalSearchQueryState({
        value: searchValue,
    });

    useEffect(() => {
        setValue('search', state);
    }, [setValue, state]);

    const handleKeyDown = async (event: React.KeyboardEvent<HTMLInputElement>) => {
        const trimmed = event.currentTarget.value.trim();
        if (event.key === 'Enter' && trimmed) {
            void setQuerySearchValue(trimmed || null);
            await handleSubmit();
        }
    };

    const handleBlur = async (event: React.FocusEvent<HTMLInputElement>) => {
        if (event.currentTarget.value.trim()) {
            const trimmed = searchValue?.trim();
            void setQuerySearchValue(trimmed || null);
            await handleSubmit();
        }
    };

    return {
        handleKeyDown,
        handleBlur,
        control,
        errors,
        clearErrors,
    };
};
